import styled from 'styled-components';

export const NoAccessContainer = styled.div`
  display: flex;
  height: 80vh;
  gap: 29px;
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-flow: column wrap;
`;

export const NoAccessTitle = styled.div`
  color: #444;
  font-size: 28px;
  font-style: normal;
  font-weight: 300;
  line-height: 31.5px;
`;

export const NoAccessDesc = styled.div`
  color: #444;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  text-align: center;
`;

export const NoAccessHomeLink = styled.a`
  color: #0076bf;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  text-align: center;

  &:hover {
    cursor: pointer;
  }
`;
